<mwc-spin [mwcIndicator]="customSpinTpl" [mwcSpinning]="isSpinning"></mwc-spin>
<mwc-page-header *ngIf="!isSpinning" mwcType="page" class="campaigns-header campaigns-view-header">
  <mwc-page-header-title>
    <div class="d-flex align-items-center gap-2">
      <div class="d-flex align-items-center gap-3">
        <button mwc-button mwcSize="small" mwcType="default-color" class="mwc-text-sm-medium" (click)="allCampaign()"><span mwc-icon mwcIconfont="arrow-left"></span></button>
        <div class="campaign-folder-icon"><span mwc-icon mwcIconfont="folder"></span></div>
      </div>
      <div *ngIf="!isEditingCampaignTopic; else editCampaignTopic" style="display: flex; align-items: center; gap: 8px;flex: 1;">
        <div class="mwc-text-lg-medium mwc-color-gray-900" style="max-width: 90%;text-overflow: ellipsis;overflow: hidden;">{{ campaignData.CampaignTopic }}</div>
        <span mwc-icon mwcIconfont="edit-01" class="icon-edit" (click)="renameCampaign()" style="font-size: 18px;cursor: pointer;"></span>
      </div>
      <ng-template #editCampaignTopic>
        <div style="display: flex; align-items: center; gap: 8px;" (click)="$event.stopPropagation()">
          <input type="text" [(ngModel)]="campaignData.CampaignTopic" class="rename-input mwc-text-sm-regular" mwc-input mwcSize="small" style="box-shadow: none;"/>
          <div style="display: flex; align-items: center; gap: 8px;">
            <button mwc-button mwcSize="small" mwcType="text" class="mwc-text-sm-medium" (click)="cancelEditing(); $event.stopPropagation();"><span mwc-icon mwcIconfont="x-close" style="font-size: 18px;color: #667085;"></span></button>
            <button mwc-button mwcSize="small" mwcType="primary" class="mwc-text-sm-medium" (click)="saveCampaignTopic(); $event.stopPropagation();" style="width: 34px;height: 34px;box-shadow: none;"><span mwc-icon mwcIconfont="check" style="font-size: 18px;"></span></button>
          </div>
        </div>
      </ng-template>
    </div>
    <!-- <div class="mwc-text-sm-medium mwc-color-gray-900 mt-1">
      <span class="mwc-text-sm-regular mwc-color-gray-600">Created on: </span>{{ campaignData.createddate }}
    </div> -->
  </mwc-page-header-title>
  <mwc-page-header-extra>
    <div class="d-flex align-items-center gap-3">
      <button mwc-button mwcSize="small" mwcType="primary" class="mwc-text-sm-medium" (click)="initTemplate()"><span
          mwc-icon mwcIconfont="plus"></span> Add Content</button>
    </div>
  </mwc-page-header-extra>
</mwc-page-header>

<div *ngIf="totalRecords >= 0 && !isSpinning; else emptyStateScreen" mwc-row>
  <div mwc-col [mwcSpan]="24">
    <mwc-card [mwcBodyStyle]="{ padding:'0' }" style="box-shadow: none;" class="table-card">
      <mwc-page-header class="page-table-header">
        <mwc-page-header-title>
          <mwc-radio-group [(ngModel)]="radioValue" (ngModelChange)="postChange($event)" class="secondary-new-tabs">
            <label mwc-radio-button mwcValue="all" (click)="getBlogListByType(listTableTabs.ALL)">All</label>
            <label *ngIf="isCmsEnabled" mwc-radio-button mwcValue="scheduled"
              (click)="getBlogListByType(listTableTabs.SCHEDULED)">Scheduled</label>
            <label *ngIf="isCmsEnabled" mwc-radio-button mwcValue="published"
              (click)="getBlogListByType(listTableTabs.PUBLISHED)">Published</label>
            <label *ngIf="isCmsEnabled" mwc-radio-button mwcValue="draft"
              (click)="getBlogListByType(listTableTabs.DRAFT)">Draft</label>
            <label *ngIf="isWorkflowEnabled" mwc-radio-button mwcValue="pending"
              (click)="getBlogListByType(listTableTabs.PENDING)">In Review</label>
            <label mwc-radio-button mwcValue="trash" (click)="getBlogListByType(listTableTabs.TRASH)">Trash</label>
          </mwc-radio-group>
        </mwc-page-header-title>
        <mwc-page-header-extra style="display: flex; align-items: center;">
          <div  style="display: flex;align-items: center;gap: 12px;">
            <div *ngIf="setOfCheckedId.length > 0" class="bulk-action bulk-actions">
              <button mwc-button mwcType="default" mwcSize="small" mwc-dropdown mwcTrigger="click"
                [mwcDropdownMenu]="bulkActionsMenu" [mwcPlacement]="'bottomRight'" aria-haspopup="menu"
                class="mwc-text-sm-semibold mwc-color-gray-700 bulk-actions__trigger">
                <span>Bulk Actions</span>
                <span mwc-icon mwcIconfont="chevron-down" class="bulk-actions__caret"></span>
              </button>
              <mwc-dropdown-menu #bulkActionsMenu="mwcDropdownMenu">
                <ul mwc-menu class="bulk-actions__menu">
                  <ng-container *ngIf="radioValue !== 'trash'">
                    <li *ngIf="isCmsEnabled && isCmsBlogEnabled && canBulkPublish()" mwc-menu-item
                      class="mwc-text-sm-medium bulk-actions__item" (click)="showBulkPublishModal()"><span mwc-icon
                        mwcIconfont="upload-cloud-02" class="bulk-actions__icon"></span> {{radioValue != 'published' ? 'Publish' : 'Republish'}}  ({{bulkPublishCount()}})</li>
                    <li *ngIf="isCmsEnabled && canBulkRevert()" mwc-menu-item
                      class="mwc-text-sm-medium bulk-actions__item" (click)="showBulkRevertModal()"><span mwc-icon
                        mwcIconfont="refresh-cw-05" class="bulk-actions__icon"></span> Revert to Draft ({{bulkRevertCount()}})</li>
                    <li mwc-menu-item class="mwc-text-sm-medium bulk-actions__item bulk-actions__item--danger"
                      (click)="bulkmoveToTrashModal()"><span mwc-icon mwcIconfont="trash-01"
                        class="bulk-actions__icon"></span> Move to Trash</li>
                  </ng-container>
                  <li *ngIf="radioValue === 'trash' && canBulkRestore()" mwc-menu-item
                    class="mwc-text-sm-medium bulk-actions__item" (click)="showBulkRestoreModal()"><span mwc-icon
                      mwcIconfont="clock-refresh" class="bulk-actions__icon"></span> Restore ({{bulkRestoreCount()}})</li>
                  <li *ngIf="radioValue === 'trash'" mwc-menu-item
                    class="mwc-text-sm-medium bulk-actions__item bulk-actions__item--danger"
                    (click)="bulkDeleteModal()"><span mwc-icon mwcIconfont="trash-01"
                      class="bulk-actions__icon"></span> Delete Permanently</li>
                </ul>
              </mwc-dropdown-menu>
            </div>
            <mwc-input-group [mwcPrefix]="prefixIconSearch" style="height: 36px;width: 200px;">
              <input mwc-input type="text" class="mwc-text-sm-regular" [(ngModel)]="searchText"
                (input)="onSearch('input')" placeholder="Search" mwcSize="small" />
            </mwc-input-group>
            <ng-template #prefixIconSearch>
              <span mwc-icon mwcIconfont="search-lg" style="font-size: 18px; color: #667085;"></span>
            </ng-template>
            <ng-container *ngIf="radioValue !== 'trash'">
              <button *ngIf="campaignData.goal == 'Web Pages'" mwc-button mwcType="default" [disabled]="!btnExportEnabled" mwcSize="small" class="option-btn" mwc-dropdown  mwcTrigger="click" [mwcDropdownMenu]="menu" mwcPlacement="bottomRight" [mwcOverlayClassName]="'export-dropdown'"> Export <span mwc-icon [mwcIconfont]="'chevron-down'" style="font-size: 16px;"></span>
              </button>
              <mwc-dropdown-menu #menu="mwcDropdownMenu">
                <ul mwc-menu>
                  <li mwc-menu-item (click)="exportByType('pdf')">
                    <span mwc-icon mwcIconfont="file-pdf" style="margin-right:8px;font-size:18px;" class="mwc-color-gray-700"></span>Export to PDF
                  </li>
                  <li mwc-menu-item (click)="exportByType('docx')">
                    <span mwc-icon mwcIconfont="file-word" style="margin-right:8px;font-size:18px;" (click)="exportByType('doc')" class="mwc-color-gray-700"></span>Export to DOCX
                  </li>
                  <li mwc-menu-item (click)="exportByType('excel')">
                    <span mwc-icon mwcIconfont="file-csv" style="margin-right:8px;font-size:18px;" (click)="exportByType('excel')" class="mwc-color-gray-700"></span>Export to Excel
                  </li>
                </ul>
              </mwc-dropdown-menu>
            </ng-container>
          </div>
        </mwc-page-header-extra>
      </mwc-page-header>

      <mwc-table #CampaignsList [mwcShowPagination]="true" [mwcFrontPagination]="false" [mwcTotal]="totalRecords"
        [mwcPageSize]="pageSize" [mwcPageIndex]="pageIndex" [mwcData]="filteredCampaignListData" [mwcLoading]="loading"
        [mwcLoadingIndicator]="tableSpinTpl"
        [mwcShowPageChanger]="true" mwcPaginationAlign="space-between" (mwcQueryParams)="onQueryParamsChange($event)"
        style="border-radius: 0px; box-shadow: none;" mwcTableLayout="fixed" class="campaign-table">
        <thead>
          <tr>
            <th *ngIf="campaignData.goal == 'Web Pages' || isCmsEnabled" [mwcChecked]="checked" [mwcIndeterminate]="indeterminate" (mwcCheckedChange)="onAllChecked($event)">
              </th>
            <ng-container *ngIf="radioValue == 'all'">
              <ng-container *ngFor="let col of CampaignDataListOfColumn; let i = index">
                <th mwcColumnKey="{{col.key}}" [mwcSortFn]="true" [mwcSortDirections]="col.sortDirections"
                    [mwcSortOrder]="col.sortOrder" [mwcShowSort]="col.isSortable" [mwcWidth]="col?.width"
                    [mwcAlign]="col.align ? 'center' : 'left'" *ngIf="col.visible" [ngClass]="{'status-header-col' : col.title == 'Status'}">
                  <ng-container *ngIf="col.title == 'Status'">
                    <div class="d-flex align-items-center gap-2">
                      {{col.title}}
                      <span mwc-icon mwcIconfont="info-circle" style="font-size: 16px" [mwcTooltipTitle]="'Hover over any status to view the associated dates'"
                            [mwcTooltipPlacement]="'top'" mwc-tooltip></span>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="col.title != 'Status'">
                    {{col.title}}
                  </ng-container>
                  
                </th>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="radioValue != 'all'">
              <ng-container *ngFor="let col of CampaignDataListOfColumnWithoutStatus; let i = index">
                <th mwcColumnKey="{{col.key}}" [mwcSortFn]="true" [mwcSortDirections]="col.sortDirections"
                  [mwcSortOrder]="col.sortOrder" [mwcShowSort]="col.isSortable" [mwcWidth]="col?.width"
                  [mwcAlign]="col.align ? 'center' : 'left'" *ngIf="col.visible">{{col.title}}</th>
              </ng-container>
            </ng-container>
            <th [mwcWidth]="'100px'" style="text-align: center;"></th>
          </tr>
        </thead>
        <tbody><ng-container *ngFor="let item of CampaignsList.data">
            <ng-container *ngFor="let data of mapOfExpandedData[item.articleId]">
              <tr *ngIf="(data.parent && data.parent.expand) || !data.parent"
                [ngClass]="{'translate-list':data.parent && data.parent.expand}">
                <td *ngIf="campaignData.goal == 'Web Pages' || isCmsEnabled" [mwcChecked]="isSelected(data.articleId)"
                      [mwcDisabled]="data.status === 6"
                      (mwcCheckedChange)="onItemChecked(data.articleId, data.status, $event)" class="translate-check-box"></td>
                <td class="strong translate-title">
                  <div class="post-title-cell">
                    <div class="profile-avator">
                      <span class="profile-name">{{ data.title }}</span>
                    </div>
                    <div class="post-title-actions" [ngClass]="{'div-disabled': data.status == 0 || data.status == 6}">
                      <a *ngIf="radioValue != 'trash'" class="post-title-actions__link"
                         (click)="openArticle(data, mapOfExpandedData[item.articleId])">Edit</a>
                      <a class="post-title-actions__link post-title-actions__link--danger"
                         (click)="radioValue == 'trash' ? deleteBlog(data) : moveToTrashModal(data)">Delete</a>
                      <a *ngIf="radioValue != 'trash' && data.status == 2 && isCmsEnabled" class="post-title-actions__link"
                         (click)="viewArticle(data.articleId)">Preview</a>
                    </div>
                  </div>
                </td>
                <td [mwcShowExpand]="data.childArticles.length > 0" [(mwcExpand)]="data.expand"
                  (mwcExpandChange)="collapse(mapOfExpandedData[data.articleId], data, $event)" class="translate-column"
                  *ngIf="!data.parent">
                  <div *ngIf="data.childArticles.length > 0 && !data.expand" class="translate-parent-icons-sec">
                    <mwc-avatar mwcIcon="translate-01"
                      style="color: #155EEF;background: #D1E0FF;line-height: 24px;"></mwc-avatar>
                    <mwc-avatar [mwcText]="data.childArticles.length.toString()"
                      style="color: #475467;border: 2px solid #EAECF0;background: #F2F4F7;font-weight: 600;font-size: 14px;line-height: 28px;margin-left: -8px;"></mwc-avatar>
                  </div>
                  <div *ngIf="data.childArticles.length > 0 && data.expand" class="translate-parent-icons-sec">
                    <span mwc-icon [mwcIconfont]="data.language" style="font-size: 24px;"></span>
                  </div>
                </td>
                <td *ngIf="data.parent && data.parent.expand" class="translate-icons-sec">
                  <span mwc-icon [mwcIconfont]="data.language" style="font-size: 24px;"></span>
                </td>
                <td>
                  <div class="mwc-color-gray-600 mwc-text-sm-regular">
                    {{ data.templateName === 'Web Pages' ? (data.promptProperties?.customTemplateName || '') : data.templateName }}
                  </div>
                </td>
                <td>
                  <div mwc-typography mwcEllipsis [mwcEllipsisRows]="1"
                    class="m-0 mwc-color-gray-600 mwc-text-sm-regular">
                    {{data.createdbyname}}</div>
                </td>
                <td>
                  <div style="display: flex;align-items: center;">
                    <div class="date-formate mwc-color-gray-600 mwc-text-sm-regular">
                      <span> {{ data.createddate | date: 'MMM d, y' }} </span>
                    </div>
                  </div>
                </td>
                <td *ngIf="radioValue == 'all'">
                  <mwc-tag [mwcColor]="getStatus(data.status)" class="status-tag"
                    *ngIf="data.status != 0 && data.status !== 6" [mwcTooltipTitle]="getTooltipMessage(data)"
                             [mwcTooltipPlacement]="'top'" mwc-tooltip>
                    <span mwc-icon mwcIconfont="circle"
                      [ngClass]="{'gray-dot' : data.status == 1 || data.status == 5,'success-dot' : data.status == 2 || data.status == 9,'warning-dot' : data.status == 3,'error-dot' : data.status == 8 || data.status == 10}"></span>
                    {{ getStatusText(data)}}
                  </mwc-tag>
                  <mwc-tag [mwcColor]="'warning'" class="status-tag" *ngIf="data.status == 6">
                    <span mwc-icon mwcIconfont="loading-01" style="color: #F79009;"></span> In Progress
                  </mwc-tag>
                  <span *ngIf="data.failureReason && data.status !== 6" mwc-icon mwcIconfont="alert-triangle"
                        style="color: #F04438; font-size: 16px; margin-left: 4px; vertical-align: middle; cursor: pointer;"
                        [mwcTooltipTitle]="data.failureReason" [mwcTooltipPlacement]="'top'" mwc-tooltip></span>
                </td>
                <td style="text-align: center;" *ngIf="campaignData.goal != 'Web Pages'">
                  <mwc-progress [mwcPercent]="data.seoScore" mwcType="circle" [mwcWidth]="40" [mwcStrokeWidth]="10"
                    [mwcStatus]="getStatusColor(+(data.seoScore))" [mwcFormat]="statusFormat"
                    [ngClass]="{'div-disabled' : data.status == 0}"></mwc-progress>
                </td>
                <td style="text-align: center;">
                  <div class="action" [ngClass]="{'div-disabled' : data.status == 0 || data.status == 6}">
                    <a class="table-edit-icon" *ngIf="radioValue != 'trash'"
                      (click)="openArticle(data,mapOfExpandedData[item.articleId])"><span mwc-icon mwcIconfont="edit-01" title="Edit"></span></a>
                    <a *ngIf="radioValue == 'trash' && !data.parent" (click)="revertTrashStatus(data)"
                      title="Restore" style="color:#475467"><span mwc-icon mwcIconfont="clock-refresh"></span></a>
                    <a *ngIf="radioValue == 'trash'" (click)="deleteBlog(data)">
                      <span title="Delete" mwc-icon mwcIconfont="trash-01" style="color: #F04438 !important;"></span>
                    </a>
                    <a *ngIf="radioValue != 'trash'" mwc-dropdown mwcTrigger="click" [mwcDropdownMenu]="menu"
                      mwcPlacement="bottomRight">
                      <span mwc-icon mwcIconfont="dots-vertical" title="More options"></span>
                    </a>
                    <mwc-dropdown-menu #menu="mwcDropdownMenu">
                      <ul mwc-menu>
                        <li *ngIf="data.status == 2" mwc-menu-item (click)="viewArticle(data.articleId)">
                          <span mwc-icon mwcIconfont="eye" style="margin-right:8px;font-size: 18px;"
                                class="mwc-color-gray-700"></span> View
                        </li>
                        <li *ngIf="data.status == 2 && isCmsEnabled"
                            i18n="@@bs-draft-modal-move-to-draft-button-text" mwc-menu-item
                            (click)="moveToDraftModal(data)">
                          <span mwc-icon mwcIconfont="file-edit" style="margin-right:8px" class="mwc-color-gray-700"></span> Move to Draft
                        </li>
                        <li i18n="@@bs-post-table-col-td-dropdown-move-to-trash-text" mwc-menu-item
                            (click)="moveToTrashModal(data)" style="color: #B42318 !important;">
                          <span mwc-icon mwcIconfont="trash-01" style="margin-right:8px; color: #F04438;"></span>Move to Trash
                        </li>
                      </ul>
                    </mwc-dropdown-menu>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </mwc-table>
    </mwc-card>
  </div>
</div>
<ng-template #emptyStateScreen>
  <div *ngIf="!isSpinning" class="empty-state blog-studio-empty-state">
    <div mwc-row mwcJustify="center" mwcAlign="middle">
      <div mwc-col class="empty-state-msg">
        <div class="image-center">
          <img src="assets/images/Illustration-search.svg" alt="Illustration search"
            style="width: 172px;height: 128px;">
        </div>
        <div>
          <mwc-space [mwcDirection]="'vertical'" [mwcSize]="24" [mwcAlign]="'center'">
            <div *mwcSpaceItem class="content-center">
              <mwc-space [mwcDirection]="'vertical'" [mwcSize]="8" [mwcAlign]="'center'">
                <div *mwcSpaceItem class="mwc-text-md-medium mwc-color-gray-900">Get Started With Your First Campaign!
                </div>
                <div *mwcSpaceItem class="mwc-text-sm-regular mwc-color-gray-600" style="max-width: 500px;">
                  <div>
                    Looks like you haven’t created a campaign yet. Create your first campaign now and bring your ideas
                    to life.
                  </div>
                </div>
              </mwc-space>
            </div>
            <div *mwcSpaceItem>
              <mwc-space [mwcSize]="12">
                <button *mwcSpaceItem mwc-button mwcType="primary" mwcSize="small" class="mwc-text-sm-medium"><span
                    mwc-icon mwcIconfont="plus"></span> Create Now</button>
              </mwc-space>
            </div>
          </mwc-space>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!--delete-->
<app-delete-confirmation
  [(visible)]="isDeleteConfirmPopup"
  (confirm)="cancelDeletePopup()"
  (cancel)="cancelDeletePopup()">
</app-delete-confirmation>
<mwc-modal [(mwcVisible)]="isDraftModalVisible" mwcWidth="544px" [mwcCentered]="true"
           (mwcOnCancel)="draftModalHandleCancel()" [mwcClassName]="'cus-modal'"> 
  <ng-container *mwcModalContent>
    <div style="padding-top: 16px;">
      <div mwc-row [mwcGutter]="[16, 16]">
        <div mwc-col>
          <div>
            <div class="mwc-icon-highlight-warning-lg">
              <span mwc-icon mwcIconfont="eye-off" style="font-size: 20px;"></span>
            </div>
          </div>
        </div>
        <div mwc-col style="width: 440px;">
          <div i18n="@@bs-draft-modal-heading-text-article" class="mwc-text-lg-semibold mwc-color-gray-900">Unpublish Article?</div>
          <p i18n="@@bs-draft-modal-subheading-text-article" class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">
            Unpublishing will remove this article from your site and may impact its SEO performance.
            Are you sure you want to proceed and save it as a draft?</p>
        </div>
      </div>
    </div>
  </ng-container>
  <div *mwcModalFooter style="text-align: right;">
    <button i18n="@@bs-draft-modal-cancel-button-text" mwc-button mwcType="default" mwcSize="small" (click)="draftModalHandleCancel()">
      Cancel
    </button>
    <button i18n="@@bs-draft-modal-move-to-draft-button-text" mwc-button mwcType="primary" mwcSize="small" class="mwc-text-sm-regular mwc-btn-warning" (click)="draftModalHandleOk()" [disabled]="isButtonDisabled">
      Yes {{ countdown > 0 ? '(' + countdown + ')' : '' }}
    </button>
  </div>
</mwc-modal>
<mwc-modal [(mwcVisible)]="isRestoreTrashModalVisible" mwcWidth="544px" [mwcCentered]="true"
  (mwcOnCancel)="trashModalHandleCancel()" [mwcClassName]="'cus-modal'">
  <ng-container *mwcModalContent>
    <div mwc-row [mwcGutter]="[16, 32]" style="padding-top: 16px;">
      <div mwc-col>
        <div class="mwc-icon-highlight-primary-lg">
          <span mwc-icon mwcIconfont="clock-refresh" style="font-size: 20px;"></span>
        </div>
      </div>
      <div mwc-col>
        <div i18n="@@bs-trash-restore-modal-heading-text" class="mwc-text-lg-semibold mwc-color-gray-900">Are you sure
          you want to restore this article?</div>
        <p *ngIf="lastPublishedStatus==2" i18n="@@bs-trash-restore-modal-subheading-text-published" class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">This article will be restored as a draft.</p>
        <p *ngIf="lastPublishedStatus==1" i18n="@@bs-trash-restore-modal-subheading-text-draft" class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">This article will be restored as a draft.</p>
      </div>
    </div>
  </ng-container>
  <div *mwcModalFooter style="text-align: right;">
    <button i18n="@@bs-trash-restore-modal-cancel-button-text" mwc-button mwcType="default" mwcSize="small" (click)="trashModalHandleCancel()">Cancel</button>
    <button i18n="@@bs-trash-restore-modal-restore-button-text" mwc-button mwcType="primary" 
      mwcSize="small" (click)="trashModalHandleOk()">Restore</button>
  </div>
</mwc-modal>
<mwc-modal [(mwcVisible)]="isBulkRestoreModalVisible" mwcWidth="544px" [mwcCentered]="true"
  (mwcOnCancel)="bulkModalHandleCancel()" [mwcClassName]="'cus-modal'">
  <ng-container *mwcModalContent>
    <div style="padding-top: 16px;">
      <div mwc-row [mwcGutter]="[16, 16]" style="flex-flow: row;">
        <div mwc-col>
          <div class="mwc-icon-highlight-primary-lg"><span mwc-icon mwcIconfont="clock-refresh" style="font-size: 20px;"></span> </div>
        </div>
        <div mwc-col style="width: 440px;">
          <div i18n="@@bs-bulk-restore-modal-heading-text" class="mwc-text-lg-semibold mwc-color-gray-900"> Restore {{bulkRestoreCount()}} article(s)?</div>
          <p i18n="@@bs-bulk-restore-modal-subheading-text" class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">The selected articles will be restored as Draft.</p>
        </div>
      </div>
    </div>
  </ng-container>
  <div *mwcModalFooter style="text-align: right;">
    <button i18n="@@bs-bulk-restore-modal-cancel-button-text" mwc-button mwcType="default" mwcSize="small" (click)="bulkModalHandleCancel()">
      Cancel
    </button>
    <button i18n="@@bs-bulk-restore-modal-restore-button-text" mwc-button mwcType="primary" mwcSize="small" class="mwc-text-sm-regular" (click)="bulkRestoreHandleOk()" [disabled]="loading">
      Restore
    </button>
  </div>
</mwc-modal>
<app-delete-confirmation [deleteMessage]="'Deleting this item will permanently remove it and it cannot be recovered. Are you sure you want to continue?'"
                         [(visible)]="isDeleteModalVisible"
                         (confirm)="trashModalHandleOk()"
                         [confirmButtonText]="'Delete'"
                         (cancel)="trashModalHandleCancel()">
</app-delete-confirmation>
<app-delete-confirmation
  [(visible)]="isTrashModalVisible"
  (confirm)="trashModalHandleOk()"
  (cancel)="trashModalHandleCancel()">
</app-delete-confirmation>
<app-delete-confirmation
  [(visible)]="isBulkTrashModalVisible"
  (confirm)="bulkTrashModalHandleOk()"
  (cancel)="bulkTrashModalHandleCancel()">
</app-delete-confirmation>
<app-delete-confirmation
  [deleteMessage]="'Deleting this item will permanently remove it and it cannot be recovered. Are you sure you want to continue?'"
  [(visible)]="isBulkDeleteModalVisible"
  (confirm)="bulkDeleteModalHandleOk()"
  [confirmButtonText]="'Delete'"
  (cancel)="bulkDeleteModalHandleCancel()">
</app-delete-confirmation>
<mwc-modal [(mwcVisible)]="isBulkPublishModalVisible" mwcWidth="544px" [mwcCentered]="true"
  (mwcOnCancel)="bulkModalHandleCancel()" [mwcClassName]="'cus-modal'" [mwcBodyStyle]="{'padding-bottom':'0px'}">
  <ng-container *mwcModalContent>
    <div mwc-row [mwcGutter]="[16, 0]" style="padding-top: 16px;">
      <div mwc-col>
        <div>
          <div class="mwc-icon-highlight-primary-lg"><span mwc-icon mwcIconfont="upload-cloud-02"
              style="font-size: 20px;"></span> </div>
        </div>
      </div>
      <div mwc-col style="width: 440px;">
        <div class="mwc-text-lg-semibold mwc-color-gray-900">Publish {{bulkPublishCount()}} article(s)?</div>
        <p class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">
          The selected articles will be published. Already published or ineligible articles will be skipped. This process may take a few minutes.
        </p>
      </div>
    </div>
  </ng-container>
  <div *mwcModalFooter style="text-align: right;">
    <button mwc-button mwcType="default" mwcSize="small" (click)="bulkModalHandleCancel()">Cancel</button>
    <button mwc-button mwcType="primary" mwcSize="small" class="mwc-text-sm-regular"
            (click)="bulkPublishHandleOk()" [disabled]="isButtonDisabled">Publish {{ countdown > 0 ? '(' + countdown + ')' : '' }}</button>
  </div>
</mwc-modal>
<mwc-modal [(mwcVisible)]="isBulkRevertModalVisible" mwcWidth="544px" [mwcCentered]="true"
  (mwcOnCancel)="bulkModalHandleCancel()" [mwcClassName]="'cus-modal'">
  <ng-container *mwcModalContent>
    <div mwc-row [mwcGutter]="[16, 0]" style="padding-top: 16px;">
      <div mwc-col>
        <div>
          <div class="mwc-icon-highlight-primary-lg"><span mwc-icon mwcIconfont="refresh-cw-05"
              style="font-size: 20px;"></span> </div>
        </div>
      </div>
      <div mwc-col style="width: 440px;">
        <div class="mwc-text-lg-semibold mwc-color-gray-900">Revert {{bulkRevertCount()}} article(s) to Draft?</div>
        <p class="mwc-text-sm-regular mwc-color-gray-600 mt-2 mb-0">
          The selected articles will be unpublished and moved to Draft. Articles that aren't published will be skipped. Want to continue?
        </p>
      </div>
    </div>
  </ng-container>
  <div *mwcModalFooter style="text-align: right;">
    <button mwc-button mwcType="default" mwcSize="small" (click)="bulkModalHandleCancel()">Cancel</button>
    <button mwc-button mwcType="primary" mwcSize="small" class="mwc-text-sm-regular"
            (click)="bulkRevertHandleOk()" [disabled]="isButtonDisabled">Revert to Draft {{ countdown > 0 ? '(' + countdown + ')' : '' }}</button>
  </div>
</mwc-modal>
<!-- Notification -->
<ng-template #notificationTemplate let-messageData="data">
  <div style="display: flex;gap: 10px;" *ngIf="messageData.errorType == 'info'">
    <div class="mwc-icon-highlight-primary-lg" style="min-width: 40px;width: 40px;height: 40px;">
      <span mwc-icon mwcIconfont="download-02" style="font-size: 16px"></span>
    </div>
    <div>
      <div class="mwc-color-gray-700 mwc-text-sm-regular" style="line-height: 20px;width: 90%;">{{ messageData.msg }}
      </div>
    </div>
  </div>
  <div style="display: flex;gap: 10px;align-items: center;" *ngIf="messageData.errorType == 'success'">
    <div class="mwc-icon-highlight-success-md">
      <span mwc-icon mwcIconfont="check-verified-01" style="font-size: 16px"></span>
    </div>
    <div class="mwc-color-success-600 mwc-text-sm-medium">{{ messageData.msg }}</div>
  </div>
  <div style="display: flex;gap: 10px;" *ngIf="messageData.errorType == 'error'">
    <div class="mwc-icon-highlight-error-lg" style="min-width: 40px;width: 40px;height: 40px;">
      <span mwc-icon mwcIconfont="info-circle" style="font-size: 16px"></span>
    </div>
    <div class="mwc-color-error-600 mwc-text-sm-medium">{{ messageData.msg }}</div>
  </div>
</ng-template>

<ng-template #ErrorAlertTemplate>
  <div class="mwc-notification-notice-content">
    <div class="save-notification-body">
      <span mwc-icon mwcIconfont="alert-circle" style="font-size:20px" class="mwc-color-error-600"></span>
      <div class="mwc-color-error-600 mwc-text-sm-medium ">{{errorMessage}}.</div>
    </div>
  </div>
</ng-template>

<ng-template #customSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

<ng-template #tableSpinTpl>
  <div style="display: flex; justify-content: center; align-items: center; width: 100%; min-height: 150px; height: 100%;">
    <img src="assets/images/ai-loader.gif" alt="Loading" style="width: 40px; height: 40px;">
  </div>
</ng-template>

